import React, { ReactElement, useEffect, useState } from "react";
import Style from "./Adfox.module.scss";

const Adfox = (): ReactElement => {
  const [isAdfoxVisible, setIsAdfoxVisible] = useState(true);

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://yastatic.net/pcode/adfox/loader.js";
    // script.async = true;
    script.crossOrigin = "anonymous";

    document.body.appendChild(script);

    script.onload = () => {
      window.Ya.adfoxCode.create({
        ownerId: 235315,
        containerId: "adfox_162521601028967141",
        params: { pp: "i", ps: "fber", p2: "ftrw" },
      });
    };
  }, []);

  return (
    <div className={`${Style.adfox} ${isAdfoxVisible ? "" : Style.adfoxHidden}`}>
      <div id="adfox_162521601028967141" />
      <div
        className={Style.close}
        onClick={() => {
          setIsAdfoxVisible(!isAdfoxVisible);
        }}
      />
    </div>
  );
};

export default Adfox;
